module.exports = __webpack_public_path__ + "img/karaoke-party.fa4369fb.png";